var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{staticStyle:{"background":"#19191e"},attrs:{"width":"auto"}},[_c('CommentAside')],1),_c('el-container',[_c('el-header',[_c('Commenthander')],1),_c('CommentTag'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }